"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTheme = void 0;

var lodash_1 = require("lodash");

var polished_1 = require("polished");

var colors_1 = require("./colors");

var theme_light_1 = require("./theme.light");

var theme_dark_1 = require("./theme.dark");

exports.getTheme = function (props) {
  var _a = props || {},
      isDarkMode = _a.isDarkMode,
      customTheme = _a.theme;

  var colors = lodash_1.merge(isDarkMode ? colors_1.DarkColors : colors_1.LightColors, lodash_1.get(customTheme, 'colors', {}));
  var Variants = isDarkMode ? theme_dark_1.default : theme_light_1.default;
  var defaultBorderRadius = 5;
  var shadows = lodash_1.merge({
    greyLight: '0 2px 3px 0 rgba(40, 40, 40, 0.15)',
    greyMedium: '0 1px 5px 1px rgba(40,40,40,0.20)',
    greyDark: '0 2px 3px 0 rgba(40, 40, 40, 0.50)',
    error: "0 2px 3px 0 " + polished_1.transparentize(0.25, colors.red),
    disabled: "0 2px 5px " + polished_1.transparentize(0.5, colors.disabledColor),
    focus: "0 2px 3px 0 " + polished_1.transparentize(0.25, colors.primary)
  }, lodash_1.get(customTheme, 'shadows', {}));
  var baseVariants = lodash_1.merge({
    default: {
      color: colors.base,
      backgroundColor: colors.primary,
      borderColor: colors.primary,
      '&:focus': {
        borderColor: colors.base
      }
    },
    danger: {
      backgroundColor: colors.red,
      borderColor: colors.red,
      '&:focus': {
        borderColor: colors.base
      }
    },
    success: {
      backgroundColor: colors.green,
      borderColor: colors.green,
      '&:focus': {
        borderColor: colors.base
      }
    },
    warning: {
      backgroundColor: colors.yellow,
      borderColor: colors.yellow,
      '&:focus': {
        borderColor: colors.primary
      }
    },
    light: {
      backgroundColor: colors.greyLighter,
      borderColor: colors.greyLighter,
      color: colors.textColor,
      '&:focus': {
        borderColor: colors.greyDark
      }
    }
  }, lodash_1.get(customTheme, 'baseVariants', {}));
  var alertVariants = lodash_1.merge(__assign(__assign({}, baseVariants), {
    default: __assign(__assign({}, baseVariants.default), {
      color: 'white'
    })
  }), lodash_1.get(customTheme, 'alertVariants', {}));
  var toastVariants = lodash_1.merge(__assign(__assign({}, baseVariants), {
    default: __assign(__assign({}, baseVariants.default), {
      color: 'white',
      boxShadow: shadows.greyMedium,
      borderColor: polished_1.darken(0.05, colors.primary),
      borderStyle: 'solid',
      borderWidth: '0 0 3px 0',
      padding: 14,
      fontSize: 13,
      marginBottom: 10,
      width: 300,
      borderRadius: 5
    }),
    success: __assign(__assign({}, baseVariants.success), {
      borderColor: polished_1.darken(0.05, colors.green)
    }),
    danger: __assign(__assign({}, baseVariants.danger), {
      borderColor: polished_1.darken(0.05, colors.red)
    }),
    warning: __assign(__assign({}, baseVariants.warning), {
      borderColor: polished_1.darken(0.05, colors.yellow)
    }),
    light: __assign(__assign({}, baseVariants.light), {
      borderColor: polished_1.darken(0.05, colors.greyLighter)
    })
  }), lodash_1.get(customTheme, 'toastVariants', {}));
  var buttonVariants = lodash_1.merge(__assign(__assign({}, baseVariants), {
    default: __assign(__assign({}, baseVariants.default), {
      color: 'white',
      '&:hover': {
        backgroundColor: colors.primary,
        borderColor: colors.primary
      }
    }),
    success: __assign(__assign({}, baseVariants.success), {
      '&:hover': {
        backgroundColor: polished_1.darken(0.05, colors.green),
        borderColor: polished_1.darken(0.05, colors.green)
      }
    }),
    danger: __assign(__assign({}, baseVariants.danger), {
      '&:hover': {
        backgroundColor: polished_1.darken(0.05, colors.red),
        borderColor: polished_1.darken(0.05, colors.red)
      }
    }),
    warning: __assign(__assign({}, baseVariants.warning), {
      '&:hover': {
        backgroundColor: polished_1.darken(0.05, colors.yellow),
        borderColor: polished_1.darken(0.05, colors.yellow)
      }
    }),
    light: __assign(__assign({}, baseVariants.light), {
      '&:hover': {
        backgroundColor: polished_1.lighten(0.05, colors.greyLighter),
        borderColor: polished_1.lighten(0.05, colors.greyLighter)
      }
    }),
    transparent: {
      backgroundColor: 'transparent',
      color: colors.textColor,
      borderColor: 'transparent',
      '&:focus': {
        borderColor: colors.primary
      },
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    outline: {
      backgroundColor: colors.base,
      borderColor: colors.greyBlueSoft,
      color: colors.greyDark,
      boxShadow: "0px 2px 5px " + colors.greyBlueSoft,
      '&:focus': {
        borderColor: colors.greyDark
      },
      '&:hover': {
        backgroundColor: colors.greyLightest
      }
    }
  }), lodash_1.get(customTheme, 'buttonVariants', {}));
  var alertSizes = lodash_1.merge({
    default: {
      padding: 12,
      fontSize: 14,
      borderRadius: 4,
      margin: '10px 0',
      iconSize: 12
    },
    sm: {
      padding: 10,
      fontSize: 12
    },
    md: {},
    lg: {
      padding: 14,
      fontSize: 16,
      margin: '15px 0',
      borderRadius: 6
    },
    xl: {
      padding: 16,
      fontSize: 18,
      margin: '17px 0',
      borderRadius: 8
    }
  }, lodash_1.get(customTheme, 'alertSizes', {}));
  var buttonSizes = lodash_1.merge({
    default: {
      padding: '0px 18px',
      fontSize: 12,
      height: 36,
      minHeight: 36,
      borderRadius: 4
    },
    sm: {
      height: 28,
      minHeight: 28,
      fontSize: 11,
      padding: '0px 14px'
    },
    md: {},
    lg: {
      padding: '0px 20px',
      fontSize: 13,
      height: 42,
      minHeight: 42,
      borderRadius: 6
    },
    xl: {
      padding: '0px 22px',
      fontSize: 14,
      height: 50,
      minHeight: 50,
      borderRadius: 6
    }
  }, lodash_1.get(customTheme, 'buttonSizes', {}));
  var tagSizes = lodash_1.merge({
    default: {
      padding: '0 10px',
      fontSize: 11,
      borderRadius: 4,
      margin: 2,
      lineHeight: 1,
      height: 25
    },
    sm: {
      height: 24,
      fontSize: 10
    },
    md: {},
    lg: {
      height: 32,
      fontSize: 12,
      padding: '0 12px'
    },
    xl: {
      padding: '0 14px',
      height: 34,
      fontSize: 13
    }
  }, lodash_1.get(customTheme, 'tagSizes', {}));
  var tagVariants = lodash_1.merge(__assign(__assign({}, baseVariants), {
    default: __assign(__assign({}, baseVariants.default), {
      color: 'white'
    })
  }), lodash_1.get(customTheme, 'tagVariants', {}));
  var inputSizes = lodash_1.merge({
    default: {
      fontSize: 14,
      labelSize: 12,
      height: 42
    },
    sm: {
      fontSize: 12,
      labelSize: 10,
      height: 36
    },
    lg: {
      fontSize: 16,
      labelSize: 14,
      height: 16 * 3
    },
    xl: {
      fontSize: 17,
      labelSize: 15,
      height: 17 * 3
    }
  }, lodash_1.get(customTheme, 'inputSizes', {}));
  var inputVariants = lodash_1.merge({
    default: {
      color: colors.textColor,
      backgroundColor: colors.base,
      borderColor: colors.baseOffsetLighter,
      focusBorderColor: colors.primary,
      focusShadowColor: shadows.focus,
      disabledColor: colors.disabledColor,
      shadowErrorColor: shadows.error,
      errorTextColor: colors.red,
      shadowColor: shadows.greyLight,
      borderRadius: 4
    }
  }, lodash_1.get(customTheme, 'inputVariants', {}));
  var inputLabelVariants = lodash_1.merge({
    default: {
      floatingColor: colors.base,
      color: colors.textColor
    }
  }, lodash_1.get(customTheme, 'inputLabelVariants', {}));
  var tooltipVariants = lodash_1.merge(__assign({}, baseVariants), lodash_1.get(customTheme, 'tooltipVariants', {}));
  var responsiveTableContainerVariants = lodash_1.merge({
    default: {
      background: colors.base,
      borderRadius: 10,
      border: "1px solid " + colors.greyLighter,
      loadingPrimaryColor: polished_1.darken(0.01, colors.base),
      loadingSecondaryColor: polished_1.lighten(0.01, colors.base)
    }
  }, lodash_1.get(customTheme, 'responsiveTableContainerVariants', {}));
  var responsiveTableRowVariants = lodash_1.merge({
    default: {
      background: colors.base,
      borderBottom: "1px solid " + colors.greyLighter
    }
  }, lodash_1.get(customTheme, 'responsiveTableRowVariants', {}));
  var selectSizes = lodash_1.merge({
    sm: {
      fontSize: '12px',
      padding: '11px 8px 11px 8px'
    },
    md: {
      fontSize: '14px',
      padding: '13px 8px 12px 8px'
    },
    lg: {
      fontSize: '16px',
      padding: '17px 8px 14px 8px'
    },
    xl: {
      fontSize: '18px',
      padding: '20px 10px 16px 10px'
    }
  }, lodash_1.get(customTheme, 'selectSizes', {}));
  var selectVariants = lodash_1.merge({
    default: {
      backgroundColor: colors.base,
      borderColor: colors.greyLighter,
      color: colors.textColor,
      disabledColor: colors.disabledColor,
      shadowColor: shadows.greyLight,
      borderRadius: 4
    }
  }, lodash_1.get(customTheme, 'selectVariants', {}));
  var modalVariants = lodash_1.merge({
    default: {
      color: colors.textColor,
      backgroundColor: colors.base,
      borderColor: colors.baseOffsetLighter,
      backdropColor: colors.backdrop
    }
  }, lodash_1.get(customTheme, 'modalVariants', {}));
  var cardVariants = lodash_1.merge(Variants.cardVariants, lodash_1.get(customTheme, 'cardVariants', {}));
  var paginationVariants = lodash_1.merge(Variants.paginationVariants, lodash_1.get(customTheme, 'paginationVariants', {}));
  var loadableVariants = lodash_1.merge({
    default: {
      defaultAnimation: 'balls',
      color: colors.loadingColor
    }
  }, lodash_1.get(customTheme, 'loadableVariants', {}));
  var loadableSizes = lodash_1.merge({
    sm: {
      width: 35,
      height: 40,
      ballSize: 6,
      amount: 25,
      ballBorderSize: 2
    },
    md: {
      width: 70,
      height: 80,
      ballSize: 15,
      amount: 50,
      ballBorderSize: 3
    },
    lg: {
      width: 133,
      height: 160,
      ballSize: 24,
      amount: 100,
      ballBorderSize: 4
    },
    xl: {
      width: 160,
      height: 200,
      ballSize: 40,
      amount: 150,
      ballBorderSize: 5
    }
  }, lodash_1.get(customTheme, 'loadableSizes', {}));
  var collapseVariants = lodash_1.merge({
    default: {
      shadow: shadows.greyLight,
      color: colors.textColor,
      backgroundColor: colors.base,
      borderColor: colors.baseOffsetLighter,
      focusBorderColor: colors.greyLight
    }
  }, lodash_1.get(customTheme, 'collapseVariants', {}));
  var checkboxVariants = lodash_1.merge({
    default: {
      checkmarkColor: colors.base,
      backgroundColorOff: colors.baseOffset,
      backgroundColorOn: colors.baseOffset,
      borderRadius: defaultBorderRadius,
      shadowColorOff: colors.offColor,
      borderColorOn: colors.onColor,
      shadowColorOn: colors.onColor,
      borderColorOff: colors.offColor,
      disabledBorderColor: colors.disabledColor,
      disabledBackgroundColor: colors.disabledColor
    }
  }, lodash_1.get(customTheme, 'checkboxVariants', {}));
  var switchVariants = lodash_1.merge({
    default: {
      trackColorOn: colors.primary,
      trackColorOff: colors.greyLighter,
      colorOn: 'white',
      colorOff: 'white',
      shadow: shadows.greyDark
    }
  }, lodash_1.get(customTheme, 'switchVariants', {}));
  var breakpoints = lodash_1.merge({
    xxxxs: '320px',
    xxxs: '440px',
    xxs: '544px',
    xs: '768px',
    sm: '1000px',
    md: '1216px',
    lg: '1408px',
    xl: '1600px'
  }, lodash_1.get(customTheme, 'breakpoints', {}));
  var components = lodash_1.merge({
    Alert: {
      sizes: alertSizes,
      variants: alertVariants
    },
    Checkbox: {
      variants: checkboxVariants
    },
    Button: {
      sizes: buttonSizes,
      variants: buttonVariants
    },
    Tag: {
      sizes: tagSizes,
      variants: tagVariants
    },
    Input: {
      sizes: inputSizes,
      variants: inputVariants
    },
    InputLabel: {
      variants: inputLabelVariants
    },
    Toaster: {
      variants: toastVariants
    },
    Tooltip: {
      variants: tooltipVariants
    },
    ResponsiveTableContainer: {
      variants: responsiveTableContainerVariants
    },
    ResponsiveTableRow: {
      variants: responsiveTableRowVariants
    },
    RadioButton: {
      sizes: {
        default: {
          height: 20,
          width: 20,
          minWidth: 20,
          ':before': {
            width: 20,
            height: 20
          },
          ':after': {
            width: 10,
            height: 10
          }
        },
        sm: {
          height: 15,
          width: 15,
          minWidth: 15,
          marginTop: 2,
          ':before': {
            height: 15,
            width: 15
          },
          ':after': {
            width: 7,
            height: 7
          }
        },
        md: {}
      }
    },
    RadioLabel: {
      sizes: {
        default: {
          fontSize: '1rem'
        },
        sm: {
          fontSize: '0.875rem'
        },
        md: {}
      }
    },
    Select: {
      sizes: selectSizes,
      variants: selectVariants
    },
    Modal: {
      variants: modalVariants
    },
    Card: {
      variants: cardVariants
    },
    Pagination: {
      variants: paginationVariants
    },
    Loadable: {
      sizes: loadableSizes,
      variants: loadableVariants
    },
    Collapse: {
      variants: collapseVariants
    },
    Switch: {
      variants: switchVariants
    }
  }, lodash_1.get(customTheme, 'components', {}));
  var grid = lodash_1.merge({
    gutter: 20,
    columns: 12,
    maxWidth: 1200
  }, lodash_1.get(customTheme, 'grid', {}));

  var Default = __assign(__assign({}, customTheme || {}), {
    borderRadius: defaultBorderRadius,
    colors: colors,
    components: components,
    grid: grid,
    fontSize: 16,
    breakpoints: breakpoints,
    shadows: shadows
  });

  return Default;
};

exports.default = exports.getTheme();